import React from 'react'
import PointBar from '../../components/userAdmin/PointBar'
import ReskinStudentHeader from '../../components/userAdmin/ReskinStudentHeader'
import CertificatePreview from '../../components/certificate/CertificatePreview'
import Text from '../../components/atoms/Text/Text'
import { CertificateInput } from '../../utils/certificate'
import styles from './Completed.module.css'

export const TEXT_CERTIFICATE_SHARING_UNIVERSITY = 'YOUR CERTIFICATE MAY BE SUBMITTED TO YOUR INSTITUTION AND/OR SHARED PUBLICLY AS PROOF OF COURSE COMPLETION.'
export const TEXT_CERTIFICATE_SHARING_TRAIN = 'YOUR CERTIFICATE MAY BE SHARED PUBLICLY AS PROOF OF SUCCESSFUL TRAINING COMPLETION.'
export const TEXT_CERTIFICATE_RETAIN = 'PLEASE DOWNLOAD AND RETAIN THIS CERTIFICATE FOR YOUR RECORDS.'

interface CompletedCertificateViewProps {
  input: CertificateInput
  sharingText: string
  children: React.ReactNode
  stageTestId?: string
  hidePointBar?: boolean
}

const CompletedCertificateView: React.FC<CompletedCertificateViewProps> = ({
  input,
  sharingText,
  children,
  stageTestId = 'completed-certificate-stage',
  hidePointBar = false
}) => {
  return (
    <div className={styles.mainContent}>
      {!hidePointBar && (
        <ReskinStudentHeader showMenu={false}>
          <PointBar isCompleted totalExperiencePoints={100} />
        </ReskinStudentHeader>
      )}
      <div className={styles.headline}>
        <Text bold shadow size='XL' text='MISSION COMPLETE, CONGRATULATIONS!' />
      </div>
      <div className={styles.certificateStage} data-testid={stageTestId}>
        <CertificatePreview input={input} />
      </div>
      <div className={styles.actions}>
        <div className={`${styles.sharingCopy} text-dopage-primary`}>
          <Text className='text-dopage-lightBlue' bold text={sharingText} />
          <Text className='text-dopage-lightBlue' bold text={TEXT_CERTIFICATE_RETAIN} type='paragraph' />
        </div>
        {children}
      </div>
    </div>
  )
}

export default CompletedCertificateView
